import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const HatebuIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 20;
  const color = props.color || '#008FDE';
  return <Icon name={'hatebu'} size={size} color={color} />;
};

export default React.memo(HatebuIcon);
